import React from 'react'
import './Pig.css'

export default function Pig() {
  return (
    <div className="Pig">Pig!</div>
  )
}
